export { DesktopMenu } from "@widgets/menu/desktop-menu/desktop-menu";
export { MobileMenu } from "@widgets/menu/mobile-menu/mobile-menu";
export { MenuItems } from "./config";